@if (largeView) {
  <ul class="nav nav-tabs mb-2">
    @for (tab of tabsUsers | keyvalue; track tab) {
      <li class="nav-item" (click)="changeTab(tab)">
        <a
          class="nav-link"
          [ngClass]="selectedTab === tab.value ? 'active' : ''"
          >{{ tab.value }}</a
        >
      </li>
    }
  </ul>
} @else {
  <div class="mb-2">
    <select
      class="form-select form-select-lg"
      [ngModel]="selectedTab"
      (change)="selectDropDown($event)"
    >
      @for (tab of tabsUsers | keyvalue; track tab) {
        <option [value]="tab.value">
          {{ tab.value }}
        </option>
      }
    </select>
  </div>
}

<div class="tab-content">
  @if (selectedTab === tabsUsers.tab1) {
    <div class="d-flex">
      <div id="user-list-section" class="col-12 col-lg-4">
        <div class="d-flex gap-2 mb-2">
          @if (!isNativeApp) {
            <div id="add-user-button">
              <button
                class="btn btn-primary h-100"
                (click)="openAddNewUserDialog()"
                id="addUserButton"
              >
                + Add User
              </button>
            </div>
          }

          <div>
            <select
              class="form-select form-select-lg"
              role="button"
              [ngModel]="userListFilterId"
              (change)="onUserListFilter($event)"
            >
              <option [value]="''">
                {{ userListFilterId == "" ? "Showing" : "Show" }} All Users
              </option>
              @for (jType of availableJobTypes; track $index) {
                <option [value]="jType.id">
                  {{ jType?.name }}
                </option>
              }
            </select>
          </div>
        </div>

        @if (reservedUserCount) {
          <div class="d-flex justify-content-start mb-2">
            <div class="d-flex btn-group w-100">
              <button
                [ngClass]="
                  accessStatusFilter === 0
                    ? 'btn-primary text-white'
                    : 'btn-outline-primary bg-white'
                "
                class="btn fw-semibold px-3 btn-sm"
                (click)="
                  accessStatusFilter = 0;
                  userPaginationData = {};
                  previousUsers = 0;
                  pageNumUsers = 1;
                  getUserListData();
                  selectedUser = {}
                "
              >
                All
              </button>
              <button
                class="btn fw-semibold px-3 btn-sm"
                [ngClass]="
                  accessStatusFilter === 1
                    ? 'btn-success'
                    : 'btn-outline-success bg-white'
                "
                (click)="
                  accessStatusFilter = 1;
                  userPaginationData = {};
                  previousUsers = 0;
                  pageNumUsers = 1;
                  getUserListData();
                  selectedUser = {}
                "
              >
                Permanent
              </button>

              <button
                class="btn fw-semibold px-3 btn-sm"
                [ngClass]="
                  accessStatusFilter === 2
                    ? 'btn-secondary'
                    : 'btn-outline-secondary bg-white'
                "
                (click)="
                  accessStatusFilter = 2;
                  userPaginationData = {};
                  previousUsers = 0;
                  pageNumUsers = 1;
                  getUserListData();
                  selectedUser = {}
                "
              >
                Casual
              </button>
            </div>
          </div>
        }
        @if (totalUserCount > 6) {
          <div>
            <gtapp-auto-complete
              [data]="userDropDownList"
              placeHolder="Search Users"
              searchKeyword="full_name"
              [itemTemplate]="userTemplate"
              [initialValue]="userSearchString"
              (inputChanged)="onUserLookup($event)"
              (selected)="rowClick($event)"
              (submitted)="
                previousUsers = 0;
                pageNumUsers = 1;
                userSearchString = $event;
                userPaginationData = {};
                getUserListData()
              "
            >
            </gtapp-auto-complete>
            <ng-template #userTemplate let-item>
              <div>{{ item?.full_name }}</div>
            </ng-template>
          </div>
        }

        <div class="border rounded my-2 align-items-center margin-auto p-2">
          <div class="d-flex justify-content-around mb-2">
            <div
              class="d-flex gap-2 align-items-center"
              role="button"
              (click)="
                accessStatusFilter = 1;
                userPaginationData = {};
                previousUsers = 0;
                pageNumUsers = 1;
                getUserListData();
                selectedUser = {}
              "
            >
              <i class="fa-solid fa-circle text-success fs-3"></i>
              <div
                [ngClass]="accessStatusFilter == 1 ? 'fw-semibold' : ''"
                class="small"
              >
                <div>
                  <span> {{ permanentUserCount }} In Use </span>

                  @if (allotedUserCount) {
                    <!--free access users will have 0 for this-->
                    /
                    <span>{{ allotedUserCount }} Total</span>
                  }
                </div>
              </div>
            </div>

            @if (reservedUserCount) {
              <div
                class="d-flex gap-2 align-items-center"
                role="button"
                (click)="
                  accessStatusFilter = 2;
                  userPaginationData = {};
                  previousUsers = 0;
                  pageNumUsers = 1;
                  getUserListData();
                  selectedUser = {}
                "
              >
                <i class="fa-regular fa-circle text-body fs-3"></i>
                <div
                  [ngClass]="accessStatusFilter == 2 ? 'fw-semibold' : ''"
                  class="small"
                >
                  {{ reservedUserCount }} Total
                </div>
              </div>
            }
          </div>
          @if (allotedUserCount && !isFreeAccessAccount) {
            <!--free access users will have 0 for this-->
            <div class="text-center small fw-semibold">
              {{ allotedUserCount - permanentUserCount }} Permanent Slots
              Available
            </div>
          }
        </div>

        @if (
          accessStatusFilter === 2 &&
          allotedUserCount &&
          !isFreeAccessAccount &&
          !isNativeApp
        ) {
          <!--free access users will have 0 for allotedUserCount-->
          <div class="alert alert-secondary">
            <div class="mb-3">
              Casual users will incur a fee of
              <span class="fw-semibold">
                ${{ perDayPerUserPrice }} per day, per user.</span
              >
            </div>
            <div class="fw-semibold">
              This <span class="text-danger"> only applies</span> if the user
              has been assigned to a shift and/or has added any updates.
            </div>
          </div>
        }

        @if (userPaginationData[pageNumUsers]?.length) {
          <div id="dynamic-container">
            <gtapp-gt-custom-table
              [deskTopTableData]="userPaginationData[pageNumUsers]"
              [desktopTableDetails]="userDetailsTableView"
              [tableStyle]="tableStyle"
              [otherParams]="otherParamsUsers"
              (sortColumn)="sortColumnUser($event)"
              (searchColumn)="searchColumnUser($event)"
              (rowClick)="rowClick($event)"
              (paginationChange)="onChangePaginationUser($event)"
              (toggleColumn)="
                previousUsers = 0;
                pageNumUsers = 1;
                userPaginationData = {};
                toggleName = !toggleName;
                getUserListData()
              "
            ></gtapp-gt-custom-table>
          </div>
        }
      </div>

      @if (selectedUser?.id) {
        <div>
          <gtapp-add-edit-user
            [editUser]="true"
            [detailData]="selectedUser"
            [fromUserPage]="true"
            (userUpdated)="userUpdatedTriggered($event)"
          >
          </gtapp-add-edit-user>
        </div>
      }
    </div>
  }
  @if (selectedTab === tabsUsers.tab2) {
    <div class="tab-pane" [class.active]="selectedTab === tabsUsers.tab2">
      <gtapp-manage-identification></gtapp-manage-identification>
    </div>
  }
  @if (selectedTab === tabsUsers.tab3) {
    <div class="tab-pane" [class.active]="selectedTab === tabsUsers.tab3">
      <div class="p-4 col-lg-4 col-xl-3">
        <div class="mb-4">
          Users in the dispatchers group can
          <span class="fw-semibold">Add / Update</span>:
        </div>
        <div
          class="d-flex flex-column mb-5"
          [ngClass]="largeView ? 'gap-3' : 'gap-4'"
        >
          @for (item of permissionListData; track $index) {
            <div class="d-flex align-items-center gap-3 ps-2">
              <input
                [id]="item?.id"
                class="form-check-input"
                type="checkbox"
                [checked]="item?.selected"
                (change)="updateJobTypePermission(item)"
              />

              <label [for]="item?.id">
                {{
                  item?.type_identity === 0 ? "Alarm Response" : item?.name
                }}</label
              >
            </div>
          }
        </div>
        <div class="col">
          <button
            (click)="updateGroupPermissions()"
            [disabled]="selectedPermissions.same"
            class="btn btn-md btn-primary w-100"
            type="button"
          >
            Update Permissions
          </button>
        </div>
      </div>
    </div>
  }
</div>
